import { HTTP } from '../../utils'

export const getEmployerReport = () => {
  return HTTP().get('employer/report')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const logActivity = (activity) => {
  let config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return HTTP().put('employer/log/', JSON.stringify(activity), config)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const createEmployer = (employer) => {
  return HTTP().put('employer/', employer)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const doCsvUploadForEmployer = (fileData) => {
  if (!fileData) {
    return
  }
  let url = '/institution/csvupload'
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getEmployerDetail = (uuid) => {
  return HTTP().get('employer/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getEmployersDetail = (institutionId) => {
  return HTTP().get('employer/institution/' + institutionId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAllJobs = (uuid) => {
  return HTTP().get('employer/jobs/category/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}



// WEBPACK FOOTER //
// ./src/app/employer/api.js